
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lending-terms",
      function () {
        return require("private-next-pages/lending-terms/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lending-terms"])
      });
    }
  